import { render, staticRenderFns } from "./store-badges-controller.vue?vue&type=template&id=7b4178d8&"
import script from "./store-badges-controller.vue?vue&type=script&lang=js&"
export * from "./store-badges-controller.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports